export { NuevoViajeRevisionCobranzaModelEdit } from "./nuevoviaje";



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/modales/index.tsx